import { ObservableFromFetch } from "../ObservableFromFetch"
import CheckOneTimePIN from "./Model/CheckOneTimePIN"

export default function GetOneTimePIN(params: CheckOneTimePIN) {
    const requestBody = JSON.stringify(params)
    return ObservableFromFetch<number>("FFOrderClinicStatus/SendOTP", requestBody)
}
